import React, { Component } from 'react'
import moment from 'moment'
import Button from '../../../../components/buttons/buttons.component'
import PeriodInputs from '../../../../components/form-components/period-inputs.component'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import StyledSectionHeader from '../../../../components/layout/styles/styled-section-header.style'
import PaginationComponent from '../../../../components/pagination/pagination.component'
import Title from '../../../../components/typography/title.component'
import Yup from '../../../../helpers/custom-yup'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { PartnerService } from '../../../../services/partner.service'
import { pointsExtractActions } from './points-extract.actions'
import { StyledForm } from './styles.style'
import { PaginationFooter } from './components/pagination-footer.component.jsx'

const headers = [
	{ header: 'Data da transação', key: 'date' },
	{ header: 'Origem', key: 'source' },
	{ header: 'Destino', key: 'destination' },
	{ header: 'Produto', key: 'notes' },
	{ header: 'Pontos', key: 'value' },
	{ header: 'Data de vencimento', key: 'expirationDate' }
]

const schema = Yup.object().shape({
	period: Yup.string().required('Escolha um período'),
	initialDate: Yup.string().required('Escolha um data'),
	finalDate: Yup.string().required('Escolha uma data')
})

const sortable = {
	defaultOrder: 'desc',
	cols: [
		{ key: 'date' },
		{ key: 'type' },
		{ key: 'value' },
		{ key: 'expirationDate' }
	]
}

class PointsExtract extends Component {
	constructor(props) {
		super(props)
		this.initialValues = {
			period: 30,
			initialDate: moment()
				.add(-30, 'd')
				.format('DD/MM/YYYY'),
			finalDate: moment().format('DD/MM/YYYY')
		}

		this.state = {
			...this.initialValues,
			totalPoints: 0,
			isExporting: false
		}

		this.footerComponent = () => (
			<PaginationFooter
				totalPoints={(+this.state.totalPoints).toLocaleString('pt-br')}
			/>
		)

		this.formikRender = props => formikRender(props, this.exportReport)

		this.getData = params =>
			PartnerService.getPointsExtract(params).then(data => {
				this.setState({
					totalPoints: data.rows.reduce((acc, { value }) => acc + value, 0)
				})
				return data
			})
	}

	onSubmit = values => {
		const nextState = { ...values }
		if (this.state.isExporting)
			this.setState(nextState, () => {
				this.props.exportData(values)
				this.setState({ isExporting: false })
			})
		else this.setState(nextState, () => this.refs.pagination.reload())
	}

	exportReport = () => {
		this.setState({ isExporting: true }, () => {
			this.refs.form.submitForm()
		})
	}

	componentDidMount() {
		this.refs.form.submitForm()
	}

	render() {
		const { initialDate, finalDate } = this.state
		return (
			<InnerPageContainer>
				<Title>Extrato de pontos Muviflex</Title>
				<StyledSectionHeader>Filtros</StyledSectionHeader>
				<Formik
					ref="form"
					initialValues={this.initialValues}
					validationSchema={schema}
					onSubmit={this.onSubmit}
					render={this.formikRender}
				/>
				<PaginationComponent
					ref="pagination"
					rowsPerPage={10}
					loadonce
					params={{ initialDate, finalDate, type: null }}
					getData={this.getData}
					footerComponent={this.footerComponent}
					headers={headers}
					sortable={sortable}
					renderRow={renderRow}
				/>
			</InnerPageContainer>
		)
	}
}

function formikRender(props, exportReport) {
	return (
		<StyledForm noValidate onSubmit={props.handleSubmit}>
			<PeriodInputs {...props} />
			<div className="buttons">
				<Button secondary type="button" onClick={exportReport}>
					Exportar
				</Button>
				<Button primary type="submit">
					Consultar
				</Button>
			</div>
		</StyledForm>
	)
}

function renderRow(rowData, headers) {
	return headers.map(({ key, align }) => (
		<td key={key} align={align}>
			<span
				title={rowData[key]}
				className={
					key == 'value'
						? `${rowData['isCredit'] ? 'blue' : 'danger'}`
						: ''
				}>
				{key == 'value' || rowData[key] ? rowData[key] : ''}
			</span>
		</td>
	))
}

const mapStateToProps = ({ partner, user }) => ({
	...user,
	partnerPoints: partner.partnerPoints
})

const mapDispatchToProps = dispatch =>
	bindActionCreators({ ...pointsExtractActions }, dispatch)

const connectedPointsExtract = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(PointsExtract)
)

export { connectedPointsExtract as ModuleRootComponent }
